import { ContainerSchema } from '@sr/types/requestNewProject';
import { getMissingContainerFields, isEmptyContainer } from './containerFields';

export const createContainerRowsSchema = ({ allowEmptyRows }: { allowEmptyRows: boolean }) =>
  ContainerSchema.array().superRefine((containers, ctx) => {
    containers.forEach((container, index) => {
      if (allowEmptyRows && isEmptyContainer(container)) {
        return;
      }

      getMissingContainerFields(container).forEach((field) => {
        ctx.addIssue({ code: 'custom', path: [index, field], message: 'form.required.text' });
      });
    });
  });
